'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('../../../_tslib-15827112.js');
var BaseController = require('../BaseController.js');

var NotificationsController = /** @class */ (function (_super) {
    _tslib.__extends(NotificationsController, _super);
    function NotificationsController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.basePath = "/Notifications";
        return _this;
    }
    NotificationsController.prototype.Get = function (domain, headers) {
        return _tslib.__awaiter(this, void 0, void 0, function () {
            var notifications, e_1;
            return _tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.MakeRequest({
                                url: this.basePath,
                                params: {
                                    domain: domain,
                                }
                            }, _tslib.__assign(_tslib.__assign({}, headers), { Sort: "-created" }))];
                    case 1:
                        notifications = _a.sent();
                        return [2 /*return*/, notifications.map(this.parseApiNotification)];
                    case 2:
                        e_1 = _a.sent();
                        return [2 /*return*/, []];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    NotificationsController.prototype.SetAsViewed = function (ids) {
        return _tslib.__awaiter(this, void 0, void 0, function () {
            var response, e_2;
            return _tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.MakeRequest({
                                method: "POST",
                                url: this.basePath + "/Viewed",
                                data: ids,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.map(this.parseApiNotification)];
                    case 2:
                        e_2 = _a.sent();
                        return [2 /*return*/, []];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    NotificationsController.prototype.parseApiNotification = function (apiNotification) {
        return _tslib.__assign(_tslib.__assign({}, apiNotification), { 
            // Temp fix. Can be deleted after https://gitlab.tiendeo.com/Login0/Auth/merge_requests/250 is merged
            info: typeof apiNotification.info === "string" ? JSON.parse(apiNotification.info) : apiNotification.info });
    };
    return NotificationsController;
}(BaseController.default));

exports.default = NotificationsController;
//# sourceMappingURL=NotificationsController.js.map
